// See ./README for how to test heap events locally
export function heapTrackEvent(eventName, eventDetails) {
    if (window.heap && window.heap.loaded) {
        window.heap.track(eventName, eventDetails);
    }
}
